import { Injectable } from '@angular/core';
import { BasecrudService } from 'src/app/shared/basecrud.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CampanhaService extends BasecrudService {

  constructor(http: HttpClient) {
    super(http, "carrossel");
  }

  public GetSlider(): any {
    return this.GetValue('carrossel/getslider');
  }

}
